import { Controller } from "@hotwired/stimulus"
import { Datepicker } from "vanillajs-datepicker"

export default class extends Controller {
  static get targets() {
    return ["button", "label", "predefinedRange", "startDatepicker", "endDatepicker"]
  }

  static get values() {
    return {
      customLabel: String,
      range: String,
      selectedRange: String,
      startDate: String,
      endDate: String,
      earliestDate: String,
    }
  }

  connect() {
    this.startDatepicker = new Datepicker(this.startDatepickerTarget, {
      title: this.startDatepickerTarget.dataset.title,
      format: "yyyy-mm-dd",
      minDate: this.earliestDateValue,
      pickLevel: 0,
      prevArrow: "‹",
      nextArrow: "›",
    })
    this.endDatepicker = new Datepicker(this.endDatepickerTarget, {
      title: this.endDatepickerTarget.dataset.title,
      format: "yyyy-mm-dd",
      minDate: this.earliestDateValue,
      pickLevel: 0,
      prevArrow: "‹",
      nextArrow: "›",
    })

    this.skipChangeDateEvent = false
    this.startDatepickerTarget.addEventListener("changeDate", this.changeDate.bind(this))
    this.endDatepickerTarget.addEventListener("changeDate", this.changeDate.bind(this))

    this._setRange(this.rangeValue)
    this._setDates(this.startDateValue, this.endDateValue)
  }

  disconnect() {
    // Destroy datepicker to avoid duplication when using back navigation because of Turbo
    this.startDatepicker.destroy()
    this.endDatepicker.destroy()
  }

  reset() {
    const dropdown = bootstrap.Dropdown.getInstance(this.buttonTarget)

    this._setRange(this.rangeValue)
    this._setDates(this.startDateValue, this.endDateValue)
    dropdown.hide()
  }

  apply() {
    const dropdown = bootstrap.Dropdown.getInstance(this.buttonTarget)

    this.rangeValue = this.selectedRangeValue
    this.startDateValue = this.startDatepicker.getDate("yyyy-mm-dd")
    this.endDateValue = this.endDatepicker.getDate("yyyy-mm-dd")
    this.dispatch("apply", {
      detail: {
        range: this.rangeValue,
        startDate: this.startDateValue,
        endDate: this.endDateValue,
      },
    })
    dropdown.hide()
  }

  changeDate() {
    if (this.skipChangeDateEvent) {
      return
    }

    this._setRange(this.customLabelValue)
  }

  selectRange(event) {
    event.stopPropagation()
    event.preventDefault()
    this._setRange(event.params.range)
    this._setDates(event.params.start, event.params.end)
  }

  _setDates(startDate, endDate) {
    this.skipChangeDateEvent = true
    this._setDate(this.startDatepicker, startDate)
    this._setDate(this.endDatepicker, endDate)
    this.skipChangeDateEvent = false
  }

  _setDate(datepicker, date) {
    if (date === undefined || date === "") {
      datepicker.setDate({ clear: true })
    } else {
      datepicker.setDate(new Date(date))
    }
  }

  _setRange(range) {
    const rangeLabel = i18n.t(`js.front.timeframe.${range}`, { missingBehavior: "" })
    this.labelTarget.innerText = rangeLabel
    this.selectedRangeValue = range

    this.predefinedRangeTargets.forEach((el) => {
      if (el.innerText === rangeLabel) {
        el.classList.add("is-active")
      } else {
        el.classList.remove("is-active")
      }
    })
  }
}
